import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React from "react";
import "./index.scss";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface IProps {
  children?: React.ReactNode | null;
  loading: boolean;
  style?: React.CSSProperties;
}

function LoadingComponent({ loading, children, style }: IProps) {
  return (
    <Spin
      wrapperClassName="nafutel-spinner"
      spinning={loading}
      indicator={antIcon}
      style={{ backgroundColor: "transparent", opacity: 1, ...style }}
    >
      {children ?? children}
    </Spin>
  );
}

export default LoadingComponent;
